import toast from "react-hot-toast";
import { IoWarningOutline, IoCheckmarkCircleOutline, IoInformationCircleOutline, IoClose } from "react-icons/io5";

export const Danger = (error: string) => {
  return toast.custom((t) => (
    <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} max-w-md w-full bg-[#ef4444] shadow-lg rounded-lg pointer-events-auto flex items-center justify-between p-4`}>
      <div className="flex items-center gap-3">
        <IoInformationCircleOutline className="text-white text-xl" />
        <p className="text-white text-sm font-medium">{error}</p>
      </div>
      <button onClick={() => toast.dismiss(t.id)} className="text-white hover:opacity-80">
        <IoClose className="text-xl" />
      </button>
    </div>
  ), {
    duration: 4000,
    position: "top-right",
  });
};

export const Warning = (error: string) => {
  return toast.custom((t) => (
    <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} max-w-md w-full bg-[#f59e0b] shadow-lg rounded-lg pointer-events-auto flex items-center justify-between p-4`}>
      <div className="flex items-center gap-3">
        <IoWarningOutline className="text-white text-xl" />
        <p className="text-white text-sm font-medium">{error}</p>
      </div>
      <button onClick={() => toast.dismiss(t.id)} className="text-white hover:opacity-80">
        <IoClose className="text-xl" />
      </button>
    </div>
  ), {
    duration: 4000,
    position: "top-right",
  });
};

export const Success = (error: string) => {
  return toast.custom((t) => (
    <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} max-w-md w-full bg-[#22c55e] shadow-lg rounded-lg pointer-events-auto flex items-center justify-between p-4`}>
      <div className="flex items-center gap-3">
        <IoCheckmarkCircleOutline className="text-white text-xl" />
        <p className="text-white text-sm font-medium">{error}</p>
      </div>
      <button onClick={() => toast.dismiss(t.id)} className="text-white hover:opacity-80">
        <IoClose className="text-xl" />
      </button>
    </div>
  ), {
    duration: 4000,
    position: "top-right",
  });
};

export const Confrim = (error?: string) => {
  return new Promise((resolve) => {
    toast(
      (t) => (
        <div className="flex flex-col gap-2">
          <p>{error ?? "Are you sure you want to delete?"}</p>
          <div className="flex gap-2">
            <button
              className="px-3 py-1 bg-red-500 text-white rounded"
              onClick={() => {
                toast.dismiss(t.id);
                resolve("catch");
              }}
            >
              Yes
            </button>
            <button
              className="px-3 py-1 bg-gray-500 text-white rounded"
              onClick={() => {
                toast.dismiss(t.id);
                resolve("cancel");
              }}
            >
              No
            </button>
          </div>
        </div>
      ),
      {
        duration: Infinity,
        position: "top-center",
        style: {
          background: "#333",
          color: "#fff",
        },
      }
    );
  });
};

// export const Success = (error: string, name?: string) => {
  
//   return toast.success(error, {
//     duration: 4000,
//     position: "top-right",
//     icon: "✅",
//     style: {
//       background: "#DCFCE7",
//       color: "#166534",
//       fontWeight: "400",
//     },
//   });
// };
